module.exports = __webpack_public_path__ + "img/body-1.02b492ee.png";